import type { DefaultValues, SubmitHandler } from 'react-hook-form';
import { useForm } from 'react-hook-form';

import type { IContentBlockFormBodyProps } from '~/components/molecules/ContentBlock';
import type { IContainerProps } from '~/components/utils/Container';
import { ContentBlock } from '~/components/molecules/ContentBlock';
import { LogInAsFormMainSection } from './LogInAsFormMainSection';

export type ILogInAsFormValues = {
  emailAddress?: string;
};

export type ILogInAsFormProps = IContainerProps &
  Omit<
    IContentBlockFormBodyProps<ILogInAsFormValues>,
    'form' | 'children' | 'onSubmit' | 'submitting'
  > & {
    defaultValues?: DefaultValues<ILogInAsFormValues>;
    onSubmit?: SubmitHandler<ILogInAsFormValues>;
  };

export const LogInAsForm: React.FC<ILogInAsFormProps> = (props) => {
  const { defaultValues, ...other } = props;

  const form = useForm<ILogInAsFormValues>({
    defaultValues,
  });

  return (
    <ContentBlock.FormBody form={form} {...other}>
      <LogInAsFormMainSection form={form} />
    </ContentBlock.FormBody>
  );
};
